import * as server from '../entries/pages/_page.server.ts.js';

export const index = 2;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/pages/_page.svelte.js')).default;
export { server };
export const server_id = "src/routes/+page.server.ts";
export const imports = ["_app/immutable/nodes/2.cc163098.js","_app/immutable/chunks/scheduler.44d63395.js","_app/immutable/chunks/index.ddc1e9bc.js","_app/immutable/chunks/Loading.924602c4.js","_app/immutable/chunks/index.651c7174.js"];
export const stylesheets = ["_app/immutable/assets/2.2a4918a6.css","_app/immutable/assets/Loading.0a6197f8.css"];
export const fonts = [];
